import { request } from '@/api-client';
import searchRequestToQueryString from '@/client/actions/searchRequestToQueryString';

const fetchSearchResults = (searchRequest: TSearchRequest): Promise<TSearchRequestAndResponse> => {
  const queryString = searchRequestToQueryString(searchRequest);
  const uri = `/lrp/api/search?${queryString}`;
  return request({
    uri,
    method: 'GET',
    credentials: 'same-origin',
  });
};

export default fetchSearchResults;
